import {useFeatures} from '@udemy/react-experimentation-provider';
import {DateIntervalType} from '@udemy/subscription-graphql';

import {BYPASS_GWG_PLAN_COMPARISON} from 'src/lib/experimentation-constants';

export function useGwgPlanPreference(): DateIntervalType | undefined {
    const {featureVariantAssignments: features} = useFeatures([BYPASS_GWG_PLAN_COMPARISON]);
    const variant = features.get(BYPASS_GWG_PLAN_COMPARISON)?.configuration
        ?.bypassPlanComparisonWith as 'control' | 'monthly' | 'annual' | undefined;

    if (variant === 'monthly') return DateIntervalType.Month;
    if (variant === 'annual') return DateIntervalType.Year;
    return undefined;
}
